import { useTranslation } from 'react-i18next'

export interface EstimationValues {
  carBase?: string | number | null
  carHp?: string | number | null
  carHc?: string | number | null
  carGas?: string | number | null
}

const ROWS = [
  { key: 'carBase', labelKey: 'subscriptionTools:estimator.car_elec_base_text' },
  { key: 'carHp', labelKey: 'subscriptionTools:estimator.car_elec_hp_text' },
  { key: 'carHc', labelKey: 'subscriptionTools:estimator.car_elec_hc_text' },
  { key: 'carGas', labelKey: 'subscriptionTools:estimator.car_gas_text' },
] as const

const usePulseEstimationResult = (values: EstimationValues) => {
  const { t } = useTranslation()

  const rows = ROWS.filter(({ key }) => {
    const value = values[key]
    return value !== undefined && value !== null && Number(value) !== 0
  }).map(({ key, labelKey }) => ({
    key,
    label: t(labelKey),
    value: `${Math.round(Number(values[key]))}${t('subscriptionTools:estimator.kwh_text')}`,
  }))

  return { rows }
}

export default usePulseEstimationResult
